// Where the frontend sends its /api requests.
//
// aiautomarker.com and thestudyden.com serve the same build, and each domain's
// Nginx proxies /api/ to the same backend. Production builds therefore call
// the API on the page's own origin, so neither domain makes cross-origin
// requests to the other. A configured REACT_APP_BACKEND_URL that names one of
// these app domains is treated as same-origin; any other configured URL (a
// separate API host, or a local backend for a local build) is still used.
// Development and tests keep the configured URL, or the local backend.
const APP_DOMAINS = ["aiautomarker.com", "thestudyden.com"];
const LOCAL_BACKEND = "http://localhost:5000";

export function resolveApiBaseUrl(configured = process.env.REACT_APP_BACKEND_URL, nodeEnv = process.env.NODE_ENV) {
  const value = typeof configured === "string" ? configured.trim().replace(/\/+$/, "") : "";
  if (nodeEnv !== "production") return value || LOCAL_BACKEND;
  if (!value) return "";
  let host;
  try {
    host = new URL(value).hostname.toLowerCase();
  } catch (_error) {
    return value;
  }
  return APP_DOMAINS.some((domain) => host === domain || host.endsWith(`.${domain}`)) ? "" : value;
}

export const API_BASE_URL = resolveApiBaseUrl();
